export const withTenant = (url, tenantId) => {
  if (!tenantId) return url;
  return url.includes("?")
    ? `${url}&tenantId=${tenantId}`
    : `${url}?tenantId=${tenantId}`;
};
